import { Route } from "react-router-dom";
import { PageErrorBoundaryLocal } from "@/components/PageErrorBoundaryLocal";
import { SoulBoundaryWithQuery } from "@/components/SoulBoundaryWithQuery";
import { ROUTES } from "@/constants/routes";
import { resilientLazy } from "@/lib/resilientImport";

const JornadaAluno = resilientLazy(() => import("@/pages/JornadaAluno"), "JornadaAluno");
const JornadaAlunoView = resilientLazy(() => import("@/pages/JornadaAlunoView"), "JornadaAlunoView");
const DiarioDaTravessia = resilientLazy(() => import("@/pages/DiarioDaTravessia"), "DiarioDaTravessia");
const StudentProfile = resilientLazy(() => import("@/pages/StudentProfile"), "StudentProfile");
const StudentBio = resilientLazy(() => import("@/pages/StudentBio"), "StudentBio");
const StudentLogin = resilientLazy(() => import("@/pages/StudentLogin"), "StudentLogin");
// StudentDashboard removed — legacy dead code, replaced by JornadaAluno
const MateriaisAluno = resilientLazy(() => import("@/pages/MateriaisAluno"), "MateriaisAluno");
const GravacoesAluno = resilientLazy(() => import("@/pages/GravacoesAluno"), "GravacoesAluno");
const AulaRoom = resilientLazy(() => import("@/pages/AulaRoom"), "AulaRoom");
const EventRoom = resilientLazy(() => import("@/pages/EventRoom"), "EventRoom");

// LMS 3.0 Pages
const Trilhas = resilientLazy(() => import("@/pages/Trilhas"), "Trilhas");
const Comunidade = resilientLazy(() => import("@/pages/Comunidade"), "Comunidade");

// Certificates & Achievements
const MeusCertificados = resilientLazy(() => import("@/pages/MeusCertificados"), "MeusCertificados");
const Conquistas = resilientLazy(() => import("@/pages/Conquistas"), "Conquistas");

export const StudentRoutes = () => (
  <>
    {/* Dashboard principal usa SoulBoundaryWithQuery para reset real de queries */}
    <Route 
      path={ROUTES.JOURNEY_STUDENT} 
      element={
        <SoulBoundaryWithQuery 
          fallbackTitle="Oops! Tivemos um tropeço"
          fallbackMessage="Algo não saiu como esperado na sua jornada. Vamos tentar de novo?"
        >
          <JornadaAluno />
        </SoulBoundaryWithQuery>
      } 
    />
    <Route 
      path={ROUTES.JOURNEY_STUDENT_ALT} 
      element={
        <SoulBoundaryWithQuery 
          fallbackTitle="Oops! Tivemos um tropeço"
          fallbackMessage="Algo não saiu como esperado na sua jornada. Vamos tentar de novo?"
        >
          <JornadaAluno />
        </SoulBoundaryWithQuery>
      } 
    />
    <Route 
      path={ROUTES.JOURNEY_STUDENT_VIEW} 
      element={
        <PageErrorBoundaryLocal fallbackMessage="Erro ao carregar visualização da jornada.">
          <JornadaAlunoView />
        </PageErrorBoundaryLocal>
      } 
    />
    <Route 
      path={ROUTES.JOURNEY_DIARY} 
      element={
        <PageErrorBoundaryLocal fallbackMessage="Erro ao carregar diário da travessia.">
          <DiarioDaTravessia />
        </PageErrorBoundaryLocal>
      }
    />
    <Route 
      path={ROUTES.STUDENT_PROFILE} 
      element={
        <PageErrorBoundaryLocal fallbackMessage="Erro ao carregar perfil do estudante.">
          <StudentProfile />
        </PageErrorBoundaryLocal>
      } 
    />
    <Route 
      path={ROUTES.STUDENT_BIO} 
      element={
        <PageErrorBoundaryLocal fallbackMessage="Erro ao carregar bio do estudante.">
          <StudentBio />
        </PageErrorBoundaryLocal>
      } 
    />
    <Route path={ROUTES.STUDENT_LOGIN} element={<StudentLogin />} />
    {/* Legacy /student-dashboard redirects to /minha-jornada-aluno */}
    <Route 
      path={ROUTES.STUDENT_DASHBOARD} 
      element={<JornadaAluno />} 
    />
    <Route 
      path={ROUTES.STUDENT_MATERIALS} 
      element={
        <PageErrorBoundaryLocal fallbackMessage="Erro ao carregar materiais.">
          <MateriaisAluno />
        </PageErrorBoundaryLocal>
      } 
    />
    <Route 
      path={ROUTES.STUDENT_RECORDINGS} 
      element={
        <PageErrorBoundaryLocal fallbackMessage="Erro ao carregar gravações.">
          <GravacoesAluno />
        </PageErrorBoundaryLocal>
      } 
    />
    <Route 
      path={ROUTES.AULA_ROOM} 
      element={
        <PageErrorBoundaryLocal fallbackMessage="Erro ao carregar sala de aula.">
          <AulaRoom />
        </PageErrorBoundaryLocal>
      }
    />
    <Route 
      path="/evento/:eventId" 
      element={
        <PageErrorBoundaryLocal fallbackMessage="Erro ao carregar evento.">
          <EventRoom />
        </PageErrorBoundaryLocal>
      } 
    />
    
    {/* LMS 3.0: Learning Paths */}
    <Route 
      path={ROUTES.LEARNING_PATHS} 
      element={
        <PageErrorBoundaryLocal fallbackMessage="Erro ao carregar trilhas.">
          <Trilhas />
        </PageErrorBoundaryLocal>
      } 
    />
    
    {/* LMS 3.0: Community / Study Groups */}
    <Route 
      path={ROUTES.COMMUNITY} 
      element={
        <PageErrorBoundaryLocal fallbackMessage="Erro ao carregar comunidade.">
          <Comunidade />
        </PageErrorBoundaryLocal>
      } 
    />
    
    {/* Certificates & Achievements */}
    <Route 
      path={ROUTES.MY_CERTIFICATES} 
      element={
        <PageErrorBoundaryLocal fallbackMessage="Erro ao carregar certificados.">
          <MeusCertificados />
        </PageErrorBoundaryLocal>
      } 
    />
    <Route 
      path={ROUTES.ACHIEVEMENTS} 
      element={
        <PageErrorBoundaryLocal fallbackMessage="Erro ao carregar conquistas.">
          <Conquistas />
        </PageErrorBoundaryLocal>
      } 
    />
  </>
);
